import { DraftOptionLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { getProduct } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

const options = [
  { value: 'CALL', label: 'Call' },
  { value: 'PUT', label: 'Put' },
] as const;

export function optionInstrumentKindView(
  optionKind: DraftOptionLeg['optionKind'],
  selectedProductCode: string,
) {
  const { venue } = getProduct(selectedProductCode);
  const isDisabled = !venueSupportsCustomStrategy(venue);
  const selectedOption =
    options.find((option) => option.value === optionKind) ?? null;
  const isValid = selectedOption != null;
  return { options, selectedOption, isValid, isDisabled };
}
